import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditsLightningPink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 10,
			cy: 10,
			r: 10,
			fill: "url(#paint0_linear_457_17917)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 16L8.3125 11.8H5.5L10.5625 4H11.6875L11.125 8.8H14.5L8.875 16H7.75Z",
			fill: "#F4F5F7"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_457_17917",
			x1: 0,
			y1: 10,
			x2: 20,
			y2: 10,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF007B" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FF3AFF"
			})]
		}) })
	]
});
const ForwardRef = forwardRef(SvgCreditsLightningPink);
export default ForwardRef;
